import { JornadaResposta } from './jornada.model';

export interface EntradaDaRegra {
  rota: string;
  tourDoPainelVisto: boolean;
  jaAbriuNestaSessao: boolean;
  /** ISO da última vez em que ESTE usuário fechou a jornada; `null` = nunca. */
  ultimaAbertura: string | null;
  jornada: JornadaResposta | null;
}

const ROTA_DO_PAINEL = '/painel/dashboard';

/** Missões cujo marco é POSTERIOR à última abertura. Empate não é novidade. */
export function novidades(jornada: JornadaResposta, ultimaAbertura: string | null): string[] {
  const limite = ultimaAbertura ? Date.parse(ultimaAbertura) : Number.NEGATIVE_INFINITY;

  return jornada.fases
    .flatMap(fase => fase.missoes)
    .filter(missao => missao.concluida_em !== null && Date.parse(missao.concluida_em) > limite)
    .map(missao => missao.id);
}

/**
 * Abre sozinha SÓ no painel, SÓ depois do tour do painel, UMA vez por sessão,
 * e só na primeira vez ou quando há conquista nova desde a última abertura
 * (spec §6.3). Fora disso, o botão do cabeçalho.
 */
export function deveAbrir(entrada: EntradaDaRegra): boolean {
  const caminho = entrada.rota.split(/[?#]/)[0].replace(/\/+$/, '');

  if (caminho !== ROTA_DO_PAINEL || !entrada.tourDoPainelVisto || entrada.jaAbriuNestaSessao || !entrada.jornada) {
    return false;
  }

  return entrada.ultimaAbertura === null || novidades(entrada.jornada, entrada.ultimaAbertura).length > 0;
}
